// extracted by mini-css-extract-plugin
export default {"parent":"LuruFloatingActionButton_parent__0yql5","disabled":"LuruFloatingActionButton_disabled__s6Uq5"};